<template>
  <div style="width:100%; margin-top:5px; margin-left: 50px; ">
    <div style="display:flex">
      <v-btn fab @click="openDialogShareBoard" small color="blue" title="share">
        <v-icon color="white">mdi-share-variant-outline</v-icon>
      </v-btn>
      <v-btn fab @click="toggleDone" small title="toggle done" color="orange">
        <v-icon v-if="!showDone">mdi-checkbox-blank-circle-outline</v-icon>
        <v-icon v-if="showDone">mdi-checkbox-marked-circle-outline</v-icon>
      </v-btn>
      <v-text-field
        style="max-width:500px; margin-left:30px; margin-right:30px;"
        v-model="newTask.title"
        v-on:keydown="keydownNewItem"
        label="New Orphan Task"
        required
      ></v-text-field>
      <v-btn fab v-on:click="toggleSplit" small title="toggle split">
        <v-icon v-if="split" color="white">mdi-arrow-split-vertical</v-icon>
        <v-icon v-if="!split" color="gray">mdi-arrow-split-vertical</v-icon>
      </v-btn>
      <v-btn fab v-on:click="toggleChart" small color="green" title="toggle chart">
        <v-icon v-if="chart" color="white">mdi-sitemap</v-icon>
        <v-icon v-if="!chart" color="gray">mdi-sitemap</v-icon>
      </v-btn>
      <v-btn fab v-on:click="toggleHistory" small title="toggle history" color="brown">
        <v-icon v-if="showHistory" color="white">mdi-history</v-icon>
        <v-icon v-if="!showHistory" color="gray">mdi-history</v-icon>
      </v-btn>
      <v-btn fab v-on:click="helpTop = true" small title="helpTop">
        <v-icon color="gray">mdi-help</v-icon>
      </v-btn>
    </div>
    <br />
    <br />

    <div style="display:flex; direction:row">
      <TasksTable
        :tasks="_tasks"
        :loadingBoard="loadingBoard"
        :currentBoardId="board.id"
        :searcher="searcher"
        @taskChanged="loadCurrentBoardTodos"
        @setForegroundTask="setForegroundTask"
        @focusOnTask="focusOnTask"
        @helptask="helpTask=true"
      ></TasksTable>
      <div style="padding:10px" />

      <TasksTable
        v-if="split === true"
        :tasks="_tasks"
        :loadingBoard="loadingBoard"
        :currentBoardId="board.id"
        :searcher="searcher"
        @taskChanged="loadCurrentBoardTodos"
        @setForegroundTask="setForegroundTask"
        @focusOnTask="focusOnTask"
        @helptask="helpTask=true"
      ></TasksTable>

      <div
        v-if="chart"
        style="width:100%; height: 1000px; background-image: linear-gradient(to bottom right, #FAF5AC, #DAF7A6); border: 3px solid blue; border-radius:10px;"
      >
        <div style></div>
        <CyView
          :tasks="_tasks"
          :deps="deps"
          :currentBoardId="board.id"
          :focusedTask="focusedTask"
          @selectedTask="onSelectedTask"
          @taskChanged="loadCurrentBoardTodos"
        ></CyView>
      </div>

      <v-card v-if="showHistory" style="min-width:200px">
        <v-card v-for="item in actionsLog" :key="item.id">
          <v-card-subtitle>
            <v-btn fab @click="revert(item)" small title="revert">
              <v-icon color="red">mdi-undo-variant</v-icon>
            </v-btn>
            <span style="margin-left:10px;">{{ item.type }}</span>
          </v-card-subtitle>
          <v-card-text>
            <div v-if="item.type === 'link tasks'">
              {{
              ((tasks, action) => {
              const t = tasks.find((_t) => _t.id === action.taskId);
              const d = tasks.find((_t) => _t.id === action.dependsOnId);
              return `${t && t.title} &lt;-- ${d && d.title}`;
              })(tasks, JSON.parse(item.action))
              }}
            </div>
            <div v-if="item.type === 'unlink tasks'">
              {{
              ((tasks, action) => {
              const t = tasks.find((_t) => _t.id === action.taskId);
              const d = tasks.find((_t) => _t.id === action.dependsOnId);
              return `${t && t.title} &lt;-- ${d && d.title}`;
              })(tasks, JSON.parse(item.action))
              }}
            </div>
            <div v-if="item.type === 'task deleted'">{{ JSON.parse(item.action).task.title }}</div>
            <div v-if="item.type === 'task created'">{{ JSON.parse(item.action).title }}</div>
            <div v-if="item.type === 'task changed'">
              <table border="1">
                <tr>
                  <th>#</th>
                  <th>from</th>
                  <th>to</th>
                </tr>
                <tr>
                  <th>done:</th>
                  <th>{{ JSON.parse(item.action).t0.done ? true : false }}</th>
                  <th>{{ JSON.parse(item.action).t1.done ? true : false }}</th>
                </tr>
                <tr>
                  <th>title:</th>
                  <th>{{ JSON.parse(item.action).t0.title }}</th>
                  <th>{{ JSON.parse(item.action).t1.title }}</th>
                </tr>
                <tr>
                  <th>description:</th>
                  <th v-html="JSON.parse(item.action).t0.description"></th>
                  <th v-html="JSON.parse(item.action).t1.description"></th>
                </tr>
              </table>
            </div>
            <!-- <div>{{ item.action }}</div> -->
          </v-card-text>
        </v-card>
      </v-card>
    </div>
    <v-bottom-sheet v-model="dialogForegroundTask" width="800">
      <Task
        :isForeground="true"
        :item="foregroundTask"
        :currentBoardId="board.id"
        :searcher="searcher"
        :tasks="_tasks"
        @taskChanged="loadCurrentBoardTodos"
        @setForegroundTask="setForegroundTask"
        @focusOnTask="focusOnTask"
        @helptask="helpTask=true"
      />
    </v-bottom-sheet>
    <v-dialog v-model="dialogShareBoard" width="800">
      <ShareBoard :board="board">ciao</ShareBoard>
    </v-dialog>
    <v-dialog v-model="helpTop" width="800">
      <div>
        <v-img src="/imgs/help-top.png" style="width: 800px; margin:auto;"></v-img>
      </div>
    </v-dialog>
    <v-dialog v-model="helpTask" width="800">
      <div>
        <v-img src="/imgs/help-task.png" style="width: 800px; margin:auto;"></v-img>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import TasksTable from "./TasksTable";
import CyView from "./CyView";
import Task from "./Task";
import FlexSearch from "flexsearch";
import makeGraph from "./makeGraph";
import ShareBoard from "./ShareBoard";
import * as api from "./api";

export default {
  name: "Boards",
  components: {
    ShareBoard,
    TasksTable,
    CyView,
    Task,
  },
  props: {
    board: Object,
  },
  data: () => ({
    helpTop: false,
    helpTask: false,
    actionsLog: [],
    split: false,
    chart: true,
    dialogForegroundTask: null,
    dialogShareBoard: false,
    foregroundTask: null,
    focusedTask: null,
    taskTableHeader: [
      { text: "Title", value: "title" },
      { value: "delButton" },
    ],
    showHistory: false,
    showDone: false,
    loadingBoard: false,
    tasks: [],
    deps: [],
    searcher: {},
    newTask: { id: "", title: "", description: "" },
  }),
  computed: {
    _tasks: function () {
      return this.tasks.filter((t) => this.showDone || !t.done);
    },
  },
  watch: {
    board: function () {
      this.loadCurrentBoardTodos();
    },
    _tasks: function () {
      this.searcher = FlexSearch.create();
      // debugger; // eslint-disable-line
      this.searcher.originalSet = this.tasks;
      this.searcher.boardId = this.board.id;
      this._tasks.forEach((t) => {
        this.searcher.add(t.id, t.title);
      });
    },
  },
  methods: {
    onSelectedTask(id) {
      console.log("select ", id);

      this.foregroundTask = this.tasks.find((t) => t.id === id);
      console.log("fg", this.foregroundTask);
      if (this.foregroundTask) {
        this.dialogForegroundTask = true;
      }
    },
    async revert(actionItem) {
      await api.undoAction(actionItem.id);
      this.loadCurrentBoardTodos();
    },
    focusOnTask(item) {
      console.log("focusing", item);
      this.focusedTask = item;
    },
    toggleHistory() {
      this.showHistory = true;
      this.chart = false;
      this.split = false;
    },
    setForegroundTask(item) {
      this.dialogForegroundTask = false;
      setTimeout(() => {
        this.dialogForegroundTask = true;
        this.foregroundTask = this.tasks.find((t) => t.id === item.id);
      }, 200);
    },
    toggleDone() {
      this.showDone = !this.showDone;
    },
    openDialogShareBoard() {
      this.dialogShareBoard = true;
    },
    toggleChart() {
      this.chart = true;
      this.showHistory = false;
      this.split = false;
    },
    toggleSplit() {
      this.chart = false;
      this.showHistory = false;
      this.split = true;
    },
    async keydownNewItem(e) {
      if (e.key === "Enter") {
        e.preventDefault();
        const newTaskResponse = await api.createNewTask(
          this.board.id,
          this.newTask
        );
        // debugger; // eslint-disable-line
        this.newTask = { id: "", title: "", description: "" };
        this.loadCurrentBoardTodos(() => {
          // debugger; // eslint-disable-line

          // console.log("focusing on new task", newTaskResponse.id);
          const newTask = this.tasks.find((t) => t.id === newTaskResponse.id);

          this.focusOnTask(newTask);
          // console.log("focused on new task", newTask);
        });
      }
    },
    async loadCurrentBoardTodos(cb) {
      this.loadingBoard = true;
      console.log("load board");
      const tasksData = await api.listTasks(this.board.id);
      try {
        const boardData = await api.getBoardData(this.board.id);
        const positions = JSON.parse(boardData.layout);
        console.log("positions", positions);
        positions.forEach((p) => {
          tasksData.tasks.forEach((t) => {
            if (t.id === p.id) {
              t.x = p.x;
              t.y = p.y;
            }
          });
        });
      } catch (err) {
        console.log(err);
      }
      const g = makeGraph(tasksData.tasks, tasksData.deps);
      this.tasks = g;
      this.deps = tasksData.deps;
      this.tasks = this.tasks.sort((t1, t2) => {
        if (t1.done && !t2.done) return 1;
        if (!t1.done && t2.done) return -1;
        if (t1.numDeps === 0 && t2.numDeps === 0) {
          if (t1.paused && !t2.paused) return 1;
          if (!t1.paused && t2.paused) return -1;
        }
        if (t1.numDeps - t2.numDeps === 0) {
          return t2.cumDepentants - t1.cumDepentants;
        }
        return t1.numDeps - t2.numDeps;
      });
      this.loadingBoard = false;
      if (this.foregroundTask) {
        this.foregroundTask = this.tasks.find(
          (t) => t.id === this.foregroundTask.id
        );
      }
      this.actionsLog = await api.listActions(this.board.id);
      if (cb) {
        setTimeout(() => {
          cb();
        }, 200);
      }
    },
  },
};
</script>
